var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Conversations")]),_c('SubPageNav',{attrs:{"links":[
  {name:'myConversations', text:'Mes Conversations'}
  ],"add":{name:'addConversation'}}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('InPageNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }